import { render, staticRenderFns } from "./form-com.vue?vue&type=template&id=b6644a5c&scoped=true&"
import script from "./form-com.vue?vue&type=script&lang=js&"
export * from "./form-com.vue?vue&type=script&lang=js&"
import style0 from "./form-com.vue?vue&type=style&index=0&id=b6644a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6644a5c",
  null
  
)

export default component.exports